import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `HeadingText` from `genesis-core` instead
 */

export const HeadingTwo = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    as="h2"
    color="onSurface.text.primary"
    typography="headingTwo"
    ref={ref}
    {...props}
  />
));

HeadingTwo.displayName = 'HeadingTwo';
